import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=4bd02222&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=4bd02222&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd02222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd02222')) {
      api.createRecord('4bd02222', component.options)
    } else {
      api.reload('4bd02222', component.options)
    }
    module.hot.accept("./footer.vue?vue&type=template&id=4bd02222&scoped=true", function () {
      api.rerender('4bd02222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/static/login/footer.vue"
export default component.exports